import { render, staticRenderFns } from "./menu-item.vue?vue&type=template&id=6568c9d1&"
import script from "./menu-item.vue?vue&type=script&lang=js&"
export * from "./menu-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Kentico\\Launchpad.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6568c9d1', component.options)
    } else {
      api.reload('6568c9d1', component.options)
    }
    module.hot.accept("./menu-item.vue?vue&type=template&id=6568c9d1&", function () {
      api.rerender('6568c9d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/custom/vue/components/ui/menu-item.vue"
export default component.exports